import { render, staticRenderFns } from "./MemberAuth.vue?vue&type=template&id=b4153ba4&scoped=true&"
import script from "./MemberAuth.vue?vue&type=script&lang=js&"
export * from "./MemberAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4153ba4",
  null
  
)

component.options.__file = "MemberAuth.vue"
export default component.exports